module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("Her har det gått noe galt tipper vi!")]), _vm._v(" "), _c('h3', [_vm._v("Hva har skjedd?")]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.send('reconsider')
      }
    }
  }, [_vm._v("Jobben er priset feil")])]), _vm._v(" "), _c('div', [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.send('reject')
      }
    }
  }, [_vm._v("Jobben skal kanselleres")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("sentiment_very_dissatisfied")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-223f877a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./requests/assets/src/components/Opq/tags/RejectTeslaOffer.vue
// module id = 106
// module chunks = 0